<template>
    <v-card>
        <v-card-title>
            {{ this.new ? 'New' : 'Update' }} Hall of Fame group
        </v-card-title>

        <v-card-text>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        label="Group name"
                        v-model="group.name"
                        required
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        label="Group slug"
                        v-model="group.slug"
                        required
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-file-input
                        accept="image/*"
                        label="Group logo"
                        v-model="newLogoImage"
                        prepend-icon="mdi-image"
                        @change="onLogoFileChange"
                    />
                </v-col>
            </v-row>
            <v-row v-if="imagePreview" justify="center">
                <v-avatar size="100">
                    <v-img :src="imagePreview" />
                </v-avatar>
            </v-row>
            <v-row>
                <v-col>
                    <v-autocomplete
                        v-model="group.page_ids"
                        chips
                        deletable-chips
                        multiple
                        label="Pages"
                        item-text="name"
                        item-value="id"
                        :items="pages"
                        :filter="searchbyNameAndPrefix"
                    >
                        <template v-slot:item="{ item }">
                            <v-list-item-title>
                                {{ item.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ item.url_prefix }}
                            </v-list-item-subtitle>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn @click="close()">
                Close
            </v-btn>
            <v-btn color="primary" @click="submit()">
                {{ this.new ? 'Create' : 'Update' }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: {
        visible: Boolean,
        currentGroup: Object,
        pages: Array,
    },

    data() {
        return {
            new: false,
            imagePreview: null,
            newLogoImage: null,
            group: {
                name: '',
                slug: '',
                page_ids: [],
            },
        };
    },

    watch: {
        visible(visible) {
            if (visible) {
                this.initialise();
            }
        },
    },

    created() {
        this.initialise();
    },

    methods: {
        initialise() {
            this.newLogoImage = null;

            if (this.currentGroup) {
                this.group = {...this.currentGroup};
                this.group.page_ids = this.group.page_ids.map(i => parseInt(i));
                if (this.currentGroup.image_url) {
                    this.imagePreview = this.currentGroup.image_url;
                } else {
                    this.imagePreview = null;
                }
            } else {
                this.new = true;
                this.imagePreview = null;
                this.group = {
                    name: '',
                    slug: '',
                    page_ids: [],
                };
            }
        },

        close() {
            this.$emit('close');
        },

        submit() {
            if (this.newLogoImage) {
                this.$emit('submit', this.group, this.imagePreview);
            } else {
                this.$emit('submit', this.group);
            }
        },

        onLogoFileChange(file) {
            this.imagePreview = null;
            if (!file) {
                return;
            }
            const reader = new FileReader();

            reader.onload = e => {
                this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        searchbyNameAndPrefix(item, queryText, itemText) {
            const inName = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
            const inPrefix = item.url_prefix.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
            return inName || inPrefix;
        },
    },
};
</script>
